export const cultivoInitialValues = {
  cultivo: "",
  envases: [],
};
